import { useLayoutEffect, useRef } from 'react';
import { startPageEntrance } from './pageEntrance';

/** Page navigation owns this effect; feed ticks and account refreshes do not. */
export function usePageEntrance(view: string, enabled = true) {
  const root = useRef<HTMLElement>(null);
  const previousView = useRef(view);
  useLayoutEffect(() => {
    const changed = previousView.current !== view;
    previousView.current = view;
    // The cold load keeps its existing loading/card appearances. Only moving
    // between sections owns the shared effect, including browser Back/Forward.
    if (changed && enabled && root.current)
      return startPageEntrance(root.current);
  }, [view, enabled]);
  return root;
}
